import type { GraphQLError } from 'graphql'

export * from './types-and-hooks'

export interface GraphqlResultError extends GraphQLError {
  errorInfo?: string | null
  errorType?: string
  location?: {
    column: number
    line: number
    sourceName?: string | null
  }[]
}

export interface GraphqlResult<T = any> {
  data?: T
  errors?: GraphqlResultError[]
  extensions?: {
    [key: string]: any
  }
}

/**
 * The error is GraphqlError
 *
 * @param error
 * @returns
 */
export const isGraphqlError = <T>(error: any): error is GraphqlResult<T> =>
  'data' in error && 'errors' in error

/**
 * Convert to Error from GraphqlError
 *
 * @param error
 * @returns Error object
 */
export const toError = (error: unknown) => {
  if (!isGraphqlError(error) || !error.errors) return null

  const firstError = error.errors.find((error) => error.message)
  if (!firstError) {
    return null
  }

  return new Error(firstError.message)
}
